@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(965_074_803)
public val Res.string.course_problem_pass_percent: StringResource by lazy {
      StringResource("string:course_problem_pass_percent", "course_problem_pass_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94118, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132150, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83989, 95),
      ))
    }

@delegate:ResourceContentHash(1_470_979_819)
public val Res.string.course_problem_presentation: StringResource by lazy {
      StringResource("string:course_problem_presentation", "course_problem_presentation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94218, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132270, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84085, 99),
      ))
    }

@delegate:ResourceContentHash(-1_238_936_848)
public val Res.string.course_problem_question_text: StringResource by lazy {
      StringResource("string:course_problem_question_text", "course_problem_question_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94326, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132450, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84185, 76),
      ))
    }

@delegate:ResourceContentHash(425_612_425)
public val Res.string.course_problem_right_answer: StringResource by lazy {
      StringResource("string:course_problem_right_answer", "course_problem_right_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94411, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132575, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84262, 143),
      ))
    }

@delegate:ResourceContentHash(-1_458_757_202)
public val Res.string.course_problem_title: StringResource by lazy {
      StringResource("string:course_problem_title", "course_problem_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94579, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132835, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84406, 60),
      ))
    }

@delegate:ResourceContentHash(1_639_701_296)
public val Res.string.course_problem_too_long: StringResource by lazy {
      StringResource("string:course_problem_too_long", "course_problem_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94636, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132904, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84467, 59),
      ))
    }

@delegate:ResourceContentHash(-661_508_060)
public val Res.string.course_problem_too_many_pages: StringResource by lazy {
      StringResource("string:course_problem_too_many_pages", "course_problem_too_many_pages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94712, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 132976, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84527, 89),
      ))
    }

@delegate:ResourceContentHash(266_554_341)
public val Res.string.course_problem_too_many_questions: StringResource by lazy {
      StringResource("string:course_problem_too_many_questions", "course_problem_too_many_questions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94802, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133122, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84617, 93),
      ))
    }

@delegate:ResourceContentHash(252_384_001)
public val Res.string.course_problem_video_link: StringResource by lazy {
      StringResource("string:course_problem_video_link", "course_problem_video_link", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 94904, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133272, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84711, 89),
      ))
    }

@delegate:ResourceContentHash(-1_285_215_596)
public val Res.string.course_progress: StringResource by lazy {
      StringResource("string:course_progress", "course_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95263, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133791, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85054, 35),
      ))
    }

@delegate:ResourceContentHash(-1_590_185_269)
public val Res.string.course_progress_done: StringResource by lazy {
      StringResource("string:course_progress_done", "course_progress_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95002, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133422, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84801, 60),
      ))
    }

@delegate:ResourceContentHash(-1_848_681_200)
public val Res.string.course_progress_empty: StringResource by lazy {
      StringResource("string:course_progress_empty", "course_progress_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95063, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133491, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 84862, 141),
      ))
    }

@delegate:ResourceContentHash(-1_706_250_435)
public val Res.string.course_progress_title: StringResource by lazy {
      StringResource("string:course_progress_title", "course_progress_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95209, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133725, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85004, 49),
      ))
    }

@delegate:ResourceContentHash(-423_918_841)
public val Res.string.course_publish: StringResource by lazy {
      StringResource("string:course_publish", "course_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95403, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133983, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85190, 34),
      ))
    }

@delegate:ResourceContentHash(-629_041_699)
public val Res.string.course_publish_changes: StringResource by lazy {
      StringResource("string:course_publish_changes", "course_publish_changes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95299, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133835, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85090, 50),
      ))
    }

@delegate:ResourceContentHash(1_625_727_979)
public val Res.string.course_published: StringResource by lazy {
      StringResource("string:course_published", "course_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95354, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 133914, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85141, 48),
      ))
    }

@delegate:ResourceContentHash(-2_032_723_815)
public val Res.string.course_question: StringResource by lazy {
      StringResource("string:course_question", "course_question", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95485, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134101, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85276, 35),
      ))
    }

@delegate:ResourceContentHash(1_837_409_804)
public val Res.string.course_question_number: StringResource by lazy {
      StringResource("string:course_question_number", "course_question_number", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95438, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134038, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85225, 50),
      ))
    }

@delegate:ResourceContentHash(-1_132_213_618)
public val Res.string.course_quiz: StringResource by lazy {
      StringResource("string:course_quiz", "course_quiz", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95698, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134474, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85473, 27),
      ))
    }

@delegate:ResourceContentHash(236_625_161)
public val Res.string.course_quiz_hint: StringResource by lazy {
      StringResource("string:course_quiz_hint", "course_quiz_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95529, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134149, 324),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85312, 160),
      ))
    }

@delegate:ResourceContentHash(-311_503_297)
public val Res.string.course_remove_option: StringResource by lazy {
      StringResource("string:course_remove_option", "course_remove_option", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95734, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134506, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85501, 52),
      ))
    }

@delegate:ResourceContentHash(-664_776_012)
public val Res.string.course_remove_page: StringResource by lazy {
      StringResource("string:course_remove_page", "course_remove_page", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95787, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134583, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85554, 46),
      ))
    }

@delegate:ResourceContentHash(-1_241_918_801)
public val Res.string.course_remove_question: StringResource by lazy {
      StringResource("string:course_remove_question", "course_remove_question", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95834, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134654, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85601, 58),
      ))
    }

@delegate:ResourceContentHash(184_205_758)
public val Res.string.course_result_failed: StringResource by lazy {
      StringResource("string:course_result_failed", "course_result_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95885, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134733, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85660, 44),
      ))
    }

@delegate:ResourceContentHash(-2_077_124_961)
public val Res.string.course_result_passed: StringResource by lazy {
      StringResource("string:course_result_passed", "course_result_passed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95930, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134790, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85705, 36),
      ))
    }

@delegate:ResourceContentHash(762_034_631)
public val Res.string.course_result_score: StringResource by lazy {
      StringResource("string:course_result_score", "course_result_score", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 95971, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134843, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85742, 75),
      ))
    }

@delegate:ResourceContentHash(675_038_159)
public val Res.string.course_result_wrong: StringResource by lazy {
      StringResource("string:course_result_wrong", "course_result_wrong", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96059, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 134963, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85818, 63),
      ))
    }

@delegate:ResourceContentHash(984_291_874)
public val Res.string.course_retry: StringResource by lazy {
      StringResource("string:course_retry", "course_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96135, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135063, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85882, 32),
      ))
    }

@delegate:ResourceContentHash(-1_585_624_519)
public val Res.string.course_right_answer: StringResource by lazy {
      StringResource("string:course_right_answer", "course_right_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96180, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135128, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85915, 59),
      ))
    }

@delegate:ResourceContentHash(1_716_406_311)
public val Res.string.course_save_draft: StringResource by lazy {
      StringResource("string:course_save_draft", "course_save_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96248, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135224, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85975, 41),
      ))
    }

@delegate:ResourceContentHash(203_101_667)
public val Res.string.course_saved: StringResource by lazy {
      StringResource("string:course_saved", "course_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96306, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135294, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86017, 36),
      ))
    }

@delegate:ResourceContentHash(-890_717_043)
public val Res.string.course_send_answers: StringResource by lazy {
      StringResource("string:course_send_answers", "course_send_answers", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96359, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135363, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86054, 43),
      ))
    }

@delegate:ResourceContentHash(1_724_663_651)
public val Res.string.course_start_quiz: StringResource by lazy {
      StringResource("string:course_start_quiz", "course_start_quiz", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96411, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135443, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86098, 45),
      ))
    }

@delegate:ResourceContentHash(-662_619_893)
public val Res.string.course_status_draft: StringResource by lazy {
      StringResource("string:course_status_draft", "course_status_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96469, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135509, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86144, 35),
      ))
    }

@delegate:ResourceContentHash(-2_109_855_266)
public val Res.string.course_status_published: StringResource by lazy {
      StringResource("string:course_status_published", "course_status_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96517, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135561, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86180, 63),
      ))
    }

@delegate:ResourceContentHash(956_633_937)
public val Res.string.course_title_field: StringResource by lazy {
      StringResource("string:course_title_field", "course_title_field", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96585, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135653, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86244, 34),
      ))
    }

@delegate:ResourceContentHash(-576_989_075)
public val Res.string.course_video_privacy: StringResource by lazy {
      StringResource("string:course_video_privacy", "course_video_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96620, 244),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 135696, 428),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86279, 224),
      ))
    }

@delegate:ResourceContentHash(-2_052_967_246)
public val Res.string.course_video_url: StringResource by lazy {
      StringResource("string:course_video_url", "course_video_url", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96865, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136125, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86504, 52),
      ))
    }

@delegate:ResourceContentHash(-2_089_082_497)
public val Res.string.course_who: StringResource by lazy {
      StringResource("string:course_who", "course_who", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96918, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136194, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86557, 34),
      ))
    }

@delegate:ResourceContentHash(509_014_025)
public val Res.string.create_roster_draft: StringResource by lazy {
      StringResource("string:create_roster_draft", "create_roster_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 96957, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136249, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86592, 55),
      ))
    }

@delegate:ResourceContentHash(760_501_322)
public val Res.string.create_roster_info: StringResource by lazy {
      StringResource("string:create_roster_info", "create_roster_info", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97029, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136341, 250),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86648, 170),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.create_roster_month: StringResource by lazy {
      StringResource("string:create_roster_month", "create_roster_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97196, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136592, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86819, 35),
      ))
    }

@delegate:ResourceContentHash(-70_152_166)
public val Res.string.create_roster_select_period: StringResource by lazy {
      StringResource("string:create_roster_select_period", "create_roster_select_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97236, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136636, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86855, 63),
      ))
    }

@delegate:ResourceContentHash(17_378_759)
public val Res.string.create_roster_title: StringResource by lazy {
      StringResource("string:create_roster_title", "create_roster_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97296, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136744, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86919, 43),
      ))
    }

@delegate:ResourceContentHash(1_386_119_363)
public val Res.string.create_roster_year: StringResource by lazy {
      StringResource("string:create_roster_year", "create_roster_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97340, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136804, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86963, 34),
      ))
    }

@delegate:ResourceContentHash(-2_086_860_498)
public val Res.string.create_workplace_business_hint: StringResource by lazy {
      StringResource("string:create_workplace_business_hint", "create_workplace_business_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97371, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136839, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86998, 74),
      ))
    }

@delegate:ResourceContentHash(-331_966_365)
public val Res.string.create_workplace_business_name: StringResource by lazy {
      StringResource("string:create_workplace_business_name", "create_workplace_business_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97462, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 136934, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87073, 58),
      ))
    }

@delegate:ResourceContentHash(-550_903_091)
public val Res.string.create_workplace_button: StringResource by lazy {
      StringResource("string:create_workplace_button", "create_workplace_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97517, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137009, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87132, 55),
      ))
    }

@delegate:ResourceContentHash(-1_664_089_992)
public val Res.string.create_workplace_description: StringResource by lazy {
      StringResource("string:create_workplace_description", "create_workplace_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97569, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137081, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87188, 120),
      ))
    }

@delegate:ResourceContentHash(-1_208_704_106)
public val Res.string.create_workplace_label: StringResource by lazy {
      StringResource("string:create_workplace_label", "create_workplace_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97706, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137290, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87309, 50),
      ))
    }

@delegate:ResourceContentHash(-1_390_287_313)
public val Res.string.create_workplace_name_hint: StringResource by lazy {
      StringResource("string:create_workplace_name_hint", "create_workplace_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97753, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137357, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87360, 70),
      ))
    }

@delegate:ResourceContentHash(-365_939_081)
public val Res.string.create_workplace_title: StringResource by lazy {
      StringResource("string:create_workplace_title", "create_workplace_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97840, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137480, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87431, 58),
      ))
    }

@delegate:ResourceContentHash(-38_244_028)
public val Res.string.daily_hours_line: StringResource by lazy {
      StringResource("string:daily_hours_line", "daily_hours_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98075, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137779, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87658, 64),
      ))
    }

@delegate:ResourceContentHash(-1_553_017_181)
public val Res.string.daily_hours_line_confirmed: StringResource by lazy {
      StringResource("string:daily_hours_line_confirmed", "daily_hours_line_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97895, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137555, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87490, 66),
      ))
    }

@delegate:ResourceContentHash(477_620_848)
public val Res.string.daily_hours_line_none: StringResource by lazy {
      StringResource("string:daily_hours_line_none", "daily_hours_line_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 97966, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137650, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87557, 53),
      ))
    }

@delegate:ResourceContentHash(1_312_180_830)
public val Res.string.daily_hours_line_plain: StringResource by lazy {
      StringResource("string:daily_hours_line_plain", "daily_hours_line_plain", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98024, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137724, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87611, 46),
      ))
    }

@delegate:ResourceContentHash(2_052_161_362)
public val Res.string.daily_records_actual_net: StringResource by lazy {
      StringResource("string:daily_records_actual_net", "daily_records_actual_net", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98148, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137880, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87723, 52),
      ))
    }

@delegate:ResourceContentHash(-649_634_456)
public val Res.string.daily_records_comments: StringResource by lazy {
      StringResource("string:daily_records_comments", "daily_records_comments", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98201, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 137949, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87776, 42),
      ))
    }

@delegate:ResourceContentHash(1_289_984_526)
public val Res.string.daily_records_costs_plan: StringResource by lazy {
      StringResource("string:daily_records_costs_plan", "daily_records_costs_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98240, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138004, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87819, 48),
      ))
    }

@delegate:ResourceContentHash(-628_768_408)
public val Res.string.daily_records_costs_real: StringResource by lazy {
      StringResource("string:daily_records_costs_real", "daily_records_costs_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98293, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138073, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87868, 48),
      ))
    }

@delegate:ResourceContentHash(174_070_213)
public val Res.string.daily_records_day_of: StringResource by lazy {
      StringResource("string:daily_records_day_of", "daily_records_day_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98350, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138142, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87917, 52),
      ))
    }

@delegate:ResourceContentHash(21_413_157)
public val Res.string.daily_records_edit_target: StringResource by lazy {
      StringResource("string:daily_records_edit_target", "daily_records_edit_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98403, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138199, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87970, 69),
      ))
    }

@delegate:ResourceContentHash(1_753_792_852)
public val Res.string.daily_records_enter_results: StringResource by lazy {
      StringResource("string:daily_records_enter_results", "daily_records_enter_results", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98477, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138301, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88040, 55),
      ))
    }

@delegate:ResourceContentHash(-1_145_797_222)
public val Res.string.daily_records_enter_takings_for: StringResource by lazy {
      StringResource("string:daily_records_enter_takings_for", "daily_records_enter_takings_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98533, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138373, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88096, 71),
      ))
    }

@delegate:ResourceContentHash(-1_779_911_650)
public val Res.string.daily_records_hours_plan: StringResource by lazy {
      StringResource("string:daily_records_hours_plan", "daily_records_hours_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98601, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138461, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88168, 48),
      ))
    }

@delegate:ResourceContentHash(-1_366_102_587)
public val Res.string.daily_records_hours_real: StringResource by lazy {
      StringResource("string:daily_records_hours_real", "daily_records_hours_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98654, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138526, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88217, 48),
      ))
    }

@delegate:ResourceContentHash(-1_003_665_851)
public val Res.string.daily_records_income_plan: StringResource by lazy {
      StringResource("string:daily_records_income_plan", "daily_records_income_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98715, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138591, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88266, 49),
      ))
    }

@delegate:ResourceContentHash(155_730_958)
public val Res.string.daily_records_income_real: StringResource by lazy {
      StringResource("string:daily_records_income_real", "daily_records_income_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98773, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138653, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88316, 53),
      ))
    }

@delegate:ResourceContentHash(1_741_795_625)
public val Res.string.daily_records_labor_income_plan: StringResource by lazy {
      StringResource("string:daily_records_labor_income_plan", "daily_records_labor_income_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98835, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138715, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88370, 71),
      ))
    }

@delegate:ResourceContentHash(2_074_738_482)
public val Res.string.daily_records_labor_income_real: StringResource by lazy {
      StringResource("string:daily_records_labor_income_real", "daily_records_labor_income_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 98915, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138811, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88442, 75),
      ))
    }

@delegate:ResourceContentHash(905_011_771)
public val Res.string.daily_records_labor_plan: StringResource by lazy {
      StringResource("string:daily_records_labor_plan", "daily_records_labor_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99003, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 138907, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88518, 64),
      ))
    }

@delegate:ResourceContentHash(-1_720_358_083)
public val Res.string.daily_records_labor_real: StringResource by lazy {
      StringResource("string:daily_records_labor_real", "daily_records_labor_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99076, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139000, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88583, 64),
      ))
    }

@delegate:ResourceContentHash(-120_319_356)
public val Res.string.daily_records_lock: StringResource by lazy {
      StringResource("string:daily_records_lock", "daily_records_lock", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99573, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139689, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89032, 38),
      ))
    }

@delegate:ResourceContentHash(1_653_748_447)
public val Res.string.daily_records_lock_confirm_text: StringResource by lazy {
      StringResource("string:daily_records_lock_confirm_text", "daily_records_lock_confirm_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99157, 195),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139093, 323),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88648, 183),
      ))
    }

@delegate:ResourceContentHash(1_155_003_078)
public val Res.string.daily_records_lock_confirm_title: StringResource by lazy {
      StringResource("string:daily_records_lock_confirm_title", "daily_records_lock_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99353, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139417, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88832, 60),
      ))
    }

@delegate:ResourceContentHash(-1_718_504_669)
public val Res.string.daily_records_lock_no_takings: StringResource by lazy {
      StringResource("string:daily_records_lock_no_takings", "daily_records_lock_no_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99418, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139490, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88893, 53),
      ))
    }

@delegate:ResourceContentHash(1_997_846_677)
public val Res.string.daily_records_locked: StringResource by lazy {
      StringResource("string:daily_records_locked", "daily_records_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99472, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139556, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88947, 84),
      ))
    }

@delegate:ResourceContentHash(-1_064_501_846)
public val Res.string.daily_records_margin_note: StringResource by lazy {
      StringResource("string:daily_records_margin_note", "daily_records_margin_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99620, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139748, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89071, 65),
      ))
    }

@delegate:ResourceContentHash(682_556_672)
public val Res.string.daily_records_margin_plan: StringResource by lazy {
      StringResource("string:daily_records_margin_plan", "daily_records_margin_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99686, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139826, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89137, 49),
      ))
    }

@delegate:ResourceContentHash(1_264_163_983)
public val Res.string.daily_records_margin_real: StringResource by lazy {
      StringResource("string:daily_records_margin_real", "daily_records_margin_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99740, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139888, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89187, 53),
      ))
    }

@delegate:ResourceContentHash(210_380_019)
public val Res.string.daily_records_month_summary: StringResource by lazy {
      StringResource("string:daily_records_month_summary", "daily_records_month_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99987, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 140251, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89410, 59),
      ))
    }

@delegate:ResourceContentHash(196_831_537)
public val Res.string.daily_records_month_summary_hint: StringResource by lazy {
      StringResource("string:daily_records_month_summary_hint", "daily_records_month_summary_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 99798, 188),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 139950, 300),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89241, 168),
      ))
    }

@delegate:ResourceContentHash(-1_092_000_478)
public val Res.string.daily_records_net_note: StringResource by lazy {
      StringResource("string:daily_records_net_note", "daily_records_net_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100047, 266),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 140335, 418),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89470, 274),
      ))
    }

@delegate:ResourceContentHash(546_109_141)
public val Res.string.daily_records_next_day: StringResource by lazy {
      StringResource("string:daily_records_next_day", "daily_records_next_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100314, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 140754, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89745, 42),
      ))
    }

@delegate:ResourceContentHash(-1_854_025_699)
public val Res.string.daily_records_notes_hide: StringResource by lazy {
      StringResource("string:daily_records_notes_hide", "daily_records_notes_hide", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100369, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 140821, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89788, 40),
      ))
    }

@delegate:ResourceContentHash(1_824_081_144)
public val Res.string.daily_records_notes_show: StringResource by lazy {
      StringResource("string:daily_records_notes_show", "daily_records_notes_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100410, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 140874, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89829, 60),
      ))
    }

@delegate:ResourceContentHash(1_785_502_085)
public val Res.string.daily_records_planned_labor: StringResource by lazy {
      StringResource("string:daily_records_planned_labor", "daily_records_planned_labor", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100467, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 140943, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89890, 71),
      ))
    }

@delegate:ResourceContentHash(-846_248_539)
public val Res.string.daily_records_planned_net: StringResource by lazy {
      StringResource("string:daily_records_planned_net", "daily_records_planned_net", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100535, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141051, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89962, 61),
      ))
    }

@delegate:ResourceContentHash(-1_893_988_414)
public val Res.string.daily_records_prev_day: StringResource by lazy {
      StringResource("string:daily_records_prev_day", "daily_records_prev_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100605, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141137, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90024, 46),
      ))
    }

@delegate:ResourceContentHash(-573_020_945)
public val Res.string.daily_records_preview_note: StringResource by lazy {
      StringResource("string:daily_records_preview_note", "daily_records_preview_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100660, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141208, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90071, 110),
      ))
    }

@delegate:ResourceContentHash(1_054_085_669)
public val Res.string.daily_records_result_plan: StringResource by lazy {
      StringResource("string:daily_records_result_plan", "daily_records_result_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100779, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141375, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90182, 49),
      ))
    }

@delegate:ResourceContentHash(-1_617_439_904)
public val Res.string.daily_records_result_real: StringResource by lazy {
      StringResource("string:daily_records_result_real", "daily_records_result_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100829, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141449, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90232, 53),
      ))
    }

@delegate:ResourceContentHash(392_466_103)
public val Res.string.daily_records_rev_plan: StringResource by lazy {
      StringResource("string:daily_records_rev_plan", "daily_records_rev_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100887, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141523, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90286, 46),
      ))
    }

@delegate:ResourceContentHash(-678_365_807)
public val Res.string.daily_records_rev_real: StringResource by lazy {
      StringResource("string:daily_records_rev_real", "daily_records_rev_real", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 100942, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141590, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90333, 46),
      ))
    }

@delegate:ResourceContentHash(1_841_611_668)
public val Res.string.daily_records_save_and_lock: StringResource by lazy {
      StringResource("string:daily_records_save_and_lock", "daily_records_save_and_lock", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101001, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141657, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90380, 59),
      ))
    }

@delegate:ResourceContentHash(1_798_573_758)
public val Res.string.daily_records_save_next: StringResource by lazy {
      StringResource("string:daily_records_save_next", "daily_records_save_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101069, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141753, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90440, 51),
      ))
    }

@delegate:ResourceContentHash(-1_575_971_023)
public val Res.string.daily_records_target_chip: StringResource by lazy {
      StringResource("string:daily_records_target_chip", "daily_records_target_chip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101121, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141825, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90492, 49),
      ))
    }

@delegate:ResourceContentHash(828_978_801)
public val Res.string.daily_records_target_header: StringResource by lazy {
      StringResource("string:daily_records_target_header", "daily_records_target_header", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101175, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141895, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90542, 43),
      ))
    }

@delegate:ResourceContentHash(-980_995_866)
public val Res.string.daily_records_target_hint: StringResource by lazy {
      StringResource("string:daily_records_target_hint", "daily_records_target_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101219, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 141943, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90586, 101),
      ))
    }

@delegate:ResourceContentHash(-1_575_971_023)
public val Res.string.daily_records_target_title: StringResource by lazy {
      StringResource("string:daily_records_target_title", "daily_records_target_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101349, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142157, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90688, 50),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString11Resources(map: MutableMap<String, StringResource>) {
  map.put("course_problem_pass_percent", Res.string.course_problem_pass_percent)
  map.put("course_problem_presentation", Res.string.course_problem_presentation)
  map.put("course_problem_question_text", Res.string.course_problem_question_text)
  map.put("course_problem_right_answer", Res.string.course_problem_right_answer)
  map.put("course_problem_title", Res.string.course_problem_title)
  map.put("course_problem_too_long", Res.string.course_problem_too_long)
  map.put("course_problem_too_many_pages", Res.string.course_problem_too_many_pages)
  map.put("course_problem_too_many_questions", Res.string.course_problem_too_many_questions)
  map.put("course_problem_video_link", Res.string.course_problem_video_link)
  map.put("course_progress", Res.string.course_progress)
  map.put("course_progress_done", Res.string.course_progress_done)
  map.put("course_progress_empty", Res.string.course_progress_empty)
  map.put("course_progress_title", Res.string.course_progress_title)
  map.put("course_publish", Res.string.course_publish)
  map.put("course_publish_changes", Res.string.course_publish_changes)
  map.put("course_published", Res.string.course_published)
  map.put("course_question", Res.string.course_question)
  map.put("course_question_number", Res.string.course_question_number)
  map.put("course_quiz", Res.string.course_quiz)
  map.put("course_quiz_hint", Res.string.course_quiz_hint)
  map.put("course_remove_option", Res.string.course_remove_option)
  map.put("course_remove_page", Res.string.course_remove_page)
  map.put("course_remove_question", Res.string.course_remove_question)
  map.put("course_result_failed", Res.string.course_result_failed)
  map.put("course_result_passed", Res.string.course_result_passed)
  map.put("course_result_score", Res.string.course_result_score)
  map.put("course_result_wrong", Res.string.course_result_wrong)
  map.put("course_retry", Res.string.course_retry)
  map.put("course_right_answer", Res.string.course_right_answer)
  map.put("course_save_draft", Res.string.course_save_draft)
  map.put("course_saved", Res.string.course_saved)
  map.put("course_send_answers", Res.string.course_send_answers)
  map.put("course_start_quiz", Res.string.course_start_quiz)
  map.put("course_status_draft", Res.string.course_status_draft)
  map.put("course_status_published", Res.string.course_status_published)
  map.put("course_title_field", Res.string.course_title_field)
  map.put("course_video_privacy", Res.string.course_video_privacy)
  map.put("course_video_url", Res.string.course_video_url)
  map.put("course_who", Res.string.course_who)
  map.put("create_roster_draft", Res.string.create_roster_draft)
  map.put("create_roster_info", Res.string.create_roster_info)
  map.put("create_roster_month", Res.string.create_roster_month)
  map.put("create_roster_select_period", Res.string.create_roster_select_period)
  map.put("create_roster_title", Res.string.create_roster_title)
  map.put("create_roster_year", Res.string.create_roster_year)
  map.put("create_workplace_business_hint", Res.string.create_workplace_business_hint)
  map.put("create_workplace_business_name", Res.string.create_workplace_business_name)
  map.put("create_workplace_button", Res.string.create_workplace_button)
  map.put("create_workplace_description", Res.string.create_workplace_description)
  map.put("create_workplace_label", Res.string.create_workplace_label)
  map.put("create_workplace_name_hint", Res.string.create_workplace_name_hint)
  map.put("create_workplace_title", Res.string.create_workplace_title)
  map.put("daily_hours_line", Res.string.daily_hours_line)
  map.put("daily_hours_line_confirmed", Res.string.daily_hours_line_confirmed)
  map.put("daily_hours_line_none", Res.string.daily_hours_line_none)
  map.put("daily_hours_line_plain", Res.string.daily_hours_line_plain)
  map.put("daily_records_actual_net", Res.string.daily_records_actual_net)
  map.put("daily_records_comments", Res.string.daily_records_comments)
  map.put("daily_records_costs_plan", Res.string.daily_records_costs_plan)
  map.put("daily_records_costs_real", Res.string.daily_records_costs_real)
  map.put("daily_records_day_of", Res.string.daily_records_day_of)
  map.put("daily_records_edit_target", Res.string.daily_records_edit_target)
  map.put("daily_records_enter_results", Res.string.daily_records_enter_results)
  map.put("daily_records_enter_takings_for", Res.string.daily_records_enter_takings_for)
  map.put("daily_records_hours_plan", Res.string.daily_records_hours_plan)
  map.put("daily_records_hours_real", Res.string.daily_records_hours_real)
  map.put("daily_records_income_plan", Res.string.daily_records_income_plan)
  map.put("daily_records_income_real", Res.string.daily_records_income_real)
  map.put("daily_records_labor_income_plan", Res.string.daily_records_labor_income_plan)
  map.put("daily_records_labor_income_real", Res.string.daily_records_labor_income_real)
  map.put("daily_records_labor_plan", Res.string.daily_records_labor_plan)
  map.put("daily_records_labor_real", Res.string.daily_records_labor_real)
  map.put("daily_records_lock", Res.string.daily_records_lock)
  map.put("daily_records_lock_confirm_text", Res.string.daily_records_lock_confirm_text)
  map.put("daily_records_lock_confirm_title", Res.string.daily_records_lock_confirm_title)
  map.put("daily_records_lock_no_takings", Res.string.daily_records_lock_no_takings)
  map.put("daily_records_locked", Res.string.daily_records_locked)
  map.put("daily_records_margin_note", Res.string.daily_records_margin_note)
  map.put("daily_records_margin_plan", Res.string.daily_records_margin_plan)
  map.put("daily_records_margin_real", Res.string.daily_records_margin_real)
  map.put("daily_records_month_summary", Res.string.daily_records_month_summary)
  map.put("daily_records_month_summary_hint", Res.string.daily_records_month_summary_hint)
  map.put("daily_records_net_note", Res.string.daily_records_net_note)
  map.put("daily_records_next_day", Res.string.daily_records_next_day)
  map.put("daily_records_notes_hide", Res.string.daily_records_notes_hide)
  map.put("daily_records_notes_show", Res.string.daily_records_notes_show)
  map.put("daily_records_planned_labor", Res.string.daily_records_planned_labor)
  map.put("daily_records_planned_net", Res.string.daily_records_planned_net)
  map.put("daily_records_prev_day", Res.string.daily_records_prev_day)
  map.put("daily_records_preview_note", Res.string.daily_records_preview_note)
  map.put("daily_records_result_plan", Res.string.daily_records_result_plan)
  map.put("daily_records_result_real", Res.string.daily_records_result_real)
  map.put("daily_records_rev_plan", Res.string.daily_records_rev_plan)
  map.put("daily_records_rev_real", Res.string.daily_records_rev_real)
  map.put("daily_records_save_and_lock", Res.string.daily_records_save_and_lock)
  map.put("daily_records_save_next", Res.string.daily_records_save_next)
  map.put("daily_records_target_chip", Res.string.daily_records_target_chip)
  map.put("daily_records_target_header", Res.string.daily_records_target_header)
  map.put("daily_records_target_hint", Res.string.daily_records_target_hint)
  map.put("daily_records_target_title", Res.string.daily_records_target_title)
}
